import React from 'react';


export const useStackState = <T>(initial?: T) => {
  const [state, setState] = React.useState<(T | undefined)[]>(initial ? [initial] : []);

  const reset = React.useCallback((value?: T) => setState(!!value || !!initial ? [value ?? initial] : []), [initial]);
  const peek = React.useCallback(() => !!state.length ? state[state.length - 1] : undefined, [state]);
  const push = React.useCallback((value: T) => setState(state.concat(value)), [state]);
  const pop = React.useCallback(() => setState(state.slice(0, -1)), [state]);
  const length = state.length;

  return {peek, push, pop, reset, length};
};
